import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Anchor } from "hesus-ui-kit";
import { UnorderList, LinkType } from "./LinkedEntityList.styled";

const LinkedEntityList = (props) => {
  const { t, enitites } = props;

  return (
    <UnorderList>
      {enitites.map((entity) => (
        <li key={entity.id}>
          <Anchor
            url={entity.uri}
            rel="noreferrer"
            target="_blank"
            styles={{
              color: "#004c83 !important",
              textDecorationLine: "underline !important",
            }}
          >
            #{entity.id} - {entity.name}
          </Anchor>
          <LinkType>[ {t(entity.type)} ]</LinkType>
        </li>
      ))}
    </UnorderList>
  );
};

LinkedEntityList.propTypes = {
  enitites: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(LinkedEntityList);
